export default __webpack_public_path__ + "static/media/Initiate's Arm-straps of the Waning Moon.7692d51a.jpg";